import { BuildingLibraryIcon, MapIcon, ChartPieIcon } from '@heroicons/react/24/outline';
import { H2, H3, Body } from '../ui/Typography';

export default function GrowingTogether() {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
      <H2 className="text-primary mb-8 text-center">Growing Together</H2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <BuildingLibraryIcon className="w-8 h-8 text-secondary" />
          </div>
          <H3 className="text-gray-900 mb-4">Acquisition Pipeline</H3>
          <Body className="text-gray-600">
            Strategic property acquisitions to expand our portfolio and increase token value
          </Body>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <MapIcon className="w-8 h-8 text-secondary" />
          </div>
          <H3 className="text-gray-900 mb-4">Geographic Expansion</H3>
          <Body className="text-gray-600">
            Diversifying across prime locations to minimize risk and maximize returns
          </Body>
        </div>
        <div className="bg-gray-50 p-6 rounded-lg">
          <div className="flex items-center mb-4">
            <ChartPieIcon className="w-8 h-8 text-secondary" />
          </div>
          <H3 className="text-gray-900 mb-4">Property Type Diversification</H3>
          <Body className="text-gray-600">
            Expanding into various property types to create a balanced portfolio
          </Body>
        </div>
      </div>
    </div>
  );
}